import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    staticClass: "complaint_list"
  }, [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "类型"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "未选择",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.complaintTypeId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "complaintTypeId", $$v);
      },
      expression: "searchForm.complaintTypeId"
    }
  }, _vm._l(_vm.complaintTypeList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.chName,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "状态"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "未选择",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.statusV2,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "statusV2", $$v);
      },
      expression: "searchForm.statusV2"
    }
  }, _vm._l(_vm.statusList, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "跟进人"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "未选择",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.operator,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "operator", $$v);
      },
      expression: "searchForm.operator"
    }
  }, _vm._l(_vm.adminList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "星标"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "未选择",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.star,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "star", $$v);
      },
      expression: "searchForm.star"
    }
  }, [_c("el-option", {
    attrs: {
      label: "是",
      value: true
    }
  }), _c("el-option", {
    attrs: {
      label: "否",
      value: false
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "投诉人手机号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入投诉人手机号"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.complainantPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "complainantPhone", $$v);
      },
      expression: "searchForm.complainantPhone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "被投诉人手机号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入被投诉人手机号"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.respondentPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "respondentPhone", $$v);
      },
      expression: "searchForm.respondentPhone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "投诉编号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入投诉编号"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "id", $$v);
      },
      expression: "searchForm.id"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索 ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          complaintTypeId: "",
          adminId: "",
          statusV2: "",
          page: 1,
          size: 10
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置 ")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "complaint.complaintTypeName",
      label: "类型",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _row$complaint, _row$complaint2;
        var row = _ref.row;
        return [_c("div", {
          staticClass: "table-base-txt"
        }, [_c("p", {
          staticClass: "wlc-f-c"
        }, [_vm._v(" " + _vm._s(row.complaint.complaintTypeName) + " "), _c("i", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_row$complaint = row.complaint) === null || _row$complaint === void 0 || (_row$complaint = _row$complaint.star) === null || _row$complaint === void 0 ? void 0 : _row$complaint.flag,
            expression: "row.complaint?.star?.flag"
          }],
          staticClass: "el-icon-star-on star-icon"
        })]), row !== null && row !== void 0 && row.statusLabel ? _c("div", [_c("el-tag", {
          staticClass: "status-tag",
          style: {
            backgroundColor: row === null || row === void 0 ? void 0 : row.statusColor
          },
          attrs: {
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(row === null || row === void 0 ? void 0 : row.statusLabel) + " ")]), (row === null || row === void 0 || (_row$complaint2 = row.complaint) === null || _row$complaint2 === void 0 ? void 0 : _row$complaint2.version) != 2 ? _c("span", {
          staticClass: "isOld"
        }, [_vm._v("旧")]) : _vm._e()], 1) : _vm._e(), _c("div", {
          staticClass: "complaint",
          class: {
            "complaint-danger": !(row !== null && row !== void 0 && row.messageCount)
          },
          on: {
            click: function click($event) {
              return _vm.goChatRecord(row);
            }
          }
        }, [_vm._v(" 消息数：" + _vm._s(row.messageCount) + " ")])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "create",
      label: "关联投诉内容",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var _row$complaint3, _row$complaint4, _row$complaint5, _row$complaint6, _row$complaint7;
        var row = _ref2.row;
        return [(row === null || row === void 0 || (_row$complaint3 = row.complaint) === null || _row$complaint3 === void 0 ? void 0 : _row$complaint3.source) == 8 ? _c("div", [_c("el-tag", {
          staticClass: "mb-8px s-c",
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.toAssociate(row, 0);
            }
          }
        }, [_vm._v(" 诈骗消息 "), _c("span", {
          staticClass: "el-icon-arrow-right"
        })]), _c("div", {
          domProps: {
            innerHTML: _vm._s((row === null || row === void 0 || (_row$complaint4 = row.complaint) === null || _row$complaint4 === void 0 || (_row$complaint4 = _row$complaint4.target) === null || _row$complaint4 === void 0 || (_row$complaint4 = _row$complaint4.extra) === null || _row$complaint4 === void 0 ? void 0 : _row$complaint4.imHitContent) || (row === null || row === void 0 || (_row$complaint5 = row.complaint) === null || _row$complaint5 === void 0 || (_row$complaint5 = _row$complaint5.target) === null || _row$complaint5 === void 0 || (_row$complaint5 = _row$complaint5.extra) === null || _row$complaint5 === void 0 ? void 0 : _row$complaint5.imContent) || "-")
          }
        })], 1) : (row === null || row === void 0 || (_row$complaint6 = row.complaint) === null || _row$complaint6 === void 0 ? void 0 : _row$complaint6.source) == 7 ? _c("div", [_c("el-tag", {
          staticClass: "mb-8px s-c",
          attrs: {
            size: "mini",
            type: "info"
          },
          on: {
            click: function click($event) {
              return _vm.toAssociate(row, 1);
            }
          }
        }, [_vm._v(" 社区评论 "), _c("span", {
          staticClass: "el-icon-arrow-right"
        })]), _c("div", {
          domProps: {
            innerHTML: _vm._s((row === null || row === void 0 || (_row$complaint7 = row.complaint) === null || _row$complaint7 === void 0 || (_row$complaint7 = _row$complaint7.target) === null || _row$complaint7 === void 0 || (_row$complaint7 = _row$complaint7.extra) === null || _row$complaint7 === void 0 ? void 0 : _row$complaint7.imContent) || "-")
          }
        })], 1) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "投诉人",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var _ref3$row = _ref3.row,
          userInfo = _ref3$row.userInfo,
          complainant = _ref3$row.complainant;
        return [_c("div", {
          staticClass: "user-card wlc-f-c"
        }, [_c("wlc-image", {
          attrs: {
            src: complainant.avatar,
            width: "24",
            enlarged: false,
            compression: true,
            to: "/user/list?phone=".concat(complainant.phone)
          }
        }), _c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })], 1), _c("div", {
          staticClass: "signTime"
        }, [_vm._v(" " + _vm._s(_vm._f("dateFormat")(complainant === null || complainant === void 0 ? void 0 : complainant.createTime, "YYYY-MM-DD"))), complainant !== null && complainant !== void 0 && complainant.createTime ? _c("span", [_vm._v(" 注册")]) : _vm._e()]), _c("div", {
          staticClass: "wlc-f-c"
        }, [_c("wlc-pop-radar-chart", {
          attrs: {
            info: complainant.userScore,
            type: complainant.userType
          }
        }), complainant.userType === 3 && complainant.brandQuarterCity ? _c("el-tag", {
          staticStyle: {
            "margin-left": "4px"
          },
          attrs: {
            type: "info",
            size: "mini"
          }
        }, [_vm._v(_vm._s(complainant.brandQuarterCity) + " ")]) : _vm._e()], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "被投诉人",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var _ref4$row = _ref4.row,
          otherUserInfo = _ref4$row.otherUserInfo,
          complained = _ref4$row.complained;
        return [_c("div", {
          staticClass: "user-card wlc-f-c"
        }, [_c("wlc-image", {
          attrs: {
            src: complained.avatar,
            width: "24",
            enlarged: false,
            compression: true,
            to: "/user/list?phone=".concat(complained.phone)
          }
        }), _c("wlc-user-pop", {
          attrs: {
            info: otherUserInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        }), complained.complainedQuickTotal > 1 ? _c("div", {
          staticClass: "complained-total",
          on: {
            click: function click($event) {
              return _vm.selectComplainedTotal(complained);
            }
          }
        }, [_vm._v(" x" + _vm._s(complained.complainedQuickTotal || 0) + " ")]) : _vm._e()], 1), _c("div", {
          staticClass: "signTime"
        }, [_vm._v(" " + _vm._s(_vm._f("dateFormat")(complained === null || complained === void 0 ? void 0 : complained.createTime, "YYYY-MM-DD"))), complained !== null && complained !== void 0 && complained.createTime ? _c("span", [_vm._v(" 注册")]) : _vm._e()]), _c("div", {
          staticClass: "wlc-f-c"
        }, [_c("wlc-pop-radar-chart", {
          attrs: {
            info: complained.userScore,
            type: complained.userType
          }
        }), complained.userType === 3 && complained.brandQuarterCity ? _c("el-tag", {
          staticStyle: {
            "margin-left": "4px"
          },
          attrs: {
            type: "info",
            size: "mini"
          }
        }, [_vm._v(_vm._s(complained.brandQuarterCity) + " ")]) : _vm._e()], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "reason",
      "min-width": "300",
      label: "投诉理由"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var _row$complaint8, _row$complaint9;
        var row = _ref5.row;
        return [_c("div", {
          staticClass: "table-base-txt"
        }, [_c("p", {
          domProps: {
            innerHTML: _vm._s(((_row$complaint8 = row.complaint) === null || _row$complaint8 === void 0 ? void 0 : _row$complaint8.reason) || "-")
          }
        }), ((_row$complaint9 = row.complaint) === null || _row$complaint9 === void 0 ? void 0 : _row$complaint9.version) == 2 ? _c("div", {
          staticClass: "flex"
        }, [row.supplementCount ? _c("div", {
          staticClass: "supplement-count wlc-f-c",
          staticStyle: {
            cursor: "pointer"
          },
          on: {
            click: function click($event) {
              return _vm.openSupplementRecordDialog(row.complaint, row);
            }
          }
        }, [row.supplementUnread ? _c("span", {
          staticClass: "red-point"
        }) : _vm._e(), _c("aside", {
          staticClass: "count wlc-f-c"
        }, [_c("span", [_vm._v("补充次数")]), _c("span", {
          staticStyle: {
            "margin-left": "2px"
          }
        }, [_vm._v(_vm._s(row.supplementCount || 0))])]), _c("span", {
          staticClass: "el-icon-arrow-right",
          staticStyle: {
            color: "#111111"
          }
        })]) : _vm._e(), row.needSupplement ? _c("div", {
          staticClass: "ml6px"
        }, [_c("p", {
          staticClass: "supplement-count !inline-block"
        }, [_vm._v("待补充")])]) : _vm._e()]) : _vm._e()])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "imgs",
      label: "投诉凭证",
      width: "143"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row;
        return _vm._l((_scope$row = scope.row) === null || _scope$row === void 0 || (_scope$row = _scope$row.complaint) === null || _scope$row === void 0 ? void 0 : _scope$row.imgs, function (item, index) {
          var _scope$row2;
          return _c("wlc-image", {
            key: item,
            attrs: {
              src: item,
              current: index,
              list: (_scope$row2 = scope.row) === null || _scope$row2 === void 0 || (_scope$row2 = _scope$row2.complaint) === null || _scope$row2 === void 0 ? void 0 : _scope$row2.imgs,
              width: "50",
              compression: true
            }
          });
        });
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "create",
      label: "投诉时间",
      width: "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var row = _ref6.row;
        return [_vm._v(" " + _vm._s(_vm._f("dateFormat")(row.complaint.create, "YYYY-MM-DD HH:mm")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "adminUser",
      label: "跟进人",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var _row$complaint0;
        var row = _ref7.row;
        return [_vm._v(" " + _vm._s(((_row$complaint0 = row.complaint) === null || _row$complaint0 === void 0 || (_row$complaint0 = _row$complaint0.handler) === null || _row$complaint0 === void 0 ? void 0 : _row$complaint0.adminName) || "-") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "complaint.id",
      label: "投诉编号",
      width: "160"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "120",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var _row$complaint1, _row$complaint10, _row$complaint11, _row$complaint12, _row$complaint13;
        var row = _ref8.row;
        return [((_row$complaint1 = row.complaint) === null || _row$complaint1 === void 0 ? void 0 : _row$complaint1.version) === 2 ? [row.complaint.statusV2 == "NEW" ? [_c("el-popconfirm", {
          key: row.complaint.id + "-follow",
          attrs: {
            placement: "top-end",
            title: "确定跟进？",
            trigger: "hover"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.setInProgress(row);
            }
          }
        }, [_c("el-button", {
          attrs: {
            slot: "reference",
            type: "text",
            size: "mini"
          },
          slot: "reference"
        }, [_vm._v("跟进")])], 1), _c("el-popconfirm", {
          key: row.complaint.id + "-suspend",
          attrs: {
            placement: "top-end",
            title: "确定搁置？",
            trigger: "hover"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.suspendComplaint(row);
            }
          }
        }, [_c("el-button", {
          staticClass: "wlc-button-danger ml-[8px]",
          attrs: {
            slot: "reference",
            type: "text",
            size: "mini"
          },
          slot: "reference"
        }, [_vm._v("搁置 ")])], 1)] : _vm._e(), row.complaint.statusV2 === "IN_PROGRESS" || row.complaint.statusV2 === "NEED_SUPPLEMENT" ? [_c("div", [_c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.openResolveDialog(row);
            }
          }
        }, [_vm._v("设为已处理 ")])], 1), _c("div", [!row.needSupplement ? _c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.openSupplementDialog(row);
            }
          }
        }, [_vm._v("补充材料 ")]) : _vm._e()], 1)] : _vm._e(), ((_row$complaint10 = row.complaint) === null || _row$complaint10 === void 0 ? void 0 : _row$complaint10.statusV2) === "RESOLVED" || ((_row$complaint11 = row.complaint) === null || _row$complaint11 === void 0 ? void 0 : _row$complaint11.statusV2) === "SUSPENDED" ? [_c("el-button", {
          staticClass: "mr8px",
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.openResolveDialog(row, "view");
            }
          }
        }, [_vm._v("查看 ")])] : _vm._e()] : [row.complaint.status == 0 ? _c("div", [_c("el-popconfirm", {
          key: row.complaint.id + 3,
          attrs: {
            placement: "top-end",
            title: "确定搁置？",
            trigger: "hover"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.setComplaintStatus(row.complaint.id, 1, row.complainant);
            }
          }
        }, [_c("el-button", {
          attrs: {
            slot: "reference",
            size: "mini",
            type: "text"
          },
          slot: "reference"
        }, [_vm._v("搁置 ")])], 1)], 1) : _vm._e(), row.complaint.status == 0 || row.complaint.status == 1 ? _c("div", [_c("el-popconfirm", {
          key: row.complaint.id + 4,
          attrs: {
            placement: "top-end",
            title: "设为已处理？",
            trigger: "hover"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.setComplaintStatus(row.complaint.id, 2, row.complainant);
            }
          }
        }, [_c("el-button", {
          attrs: {
            slot: "reference",
            size: "mini",
            type: "text"
          },
          slot: "reference"
        }, [_vm._v(" 设为已处理 ")])], 1)], 1) : _vm._e(), (row === null || row === void 0 || (_row$complaint12 = row.complaint) === null || _row$complaint12 === void 0 ? void 0 : _row$complaint12.issueReward) == 0 ? _c("div", [_c("el-popconfirm", {
          key: row.complaint.id + 5,
          attrs: {
            placement: "top-end",
            title: "确定跟进？",
            trigger: "hover"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.issueReward(row.complaint.id, row.complainant);
            }
          }
        }, [_c("el-button", {
          attrs: {
            slot: "reference",
            size: "mini",
            type: "text"
          },
          slot: "reference"
        }, [_vm._v("奖励")])], 1)], 1) : _vm._e()], _c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.setStar(row);
            }
          }
        }, [_vm._v(" " + _vm._s((_row$complaint13 = row.complaint) !== null && _row$complaint13 !== void 0 && (_row$complaint13 = _row$complaint13.star) !== null && _row$complaint13 !== void 0 && _row$complaint13.flag ? "取消星标" : "设为星标") + " ")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.size,
      "current-page": _vm.searchForm.page,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("resolve-dialog", {
    attrs: {
      visible: _vm.resolveDialogVisible,
      currentId: _vm.currentId,
      mode: _vm.resolveMode,
      type: "QUICK"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.resolveDialogVisible = $event;
      },
      confirm: _vm.getData
    }
  }), _c("supplement-dialog", {
    attrs: {
      visible: _vm.supplementDialogVisible,
      currentId: _vm.currentId,
      data: _vm.currentUser,
      type: "QUICK"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.supplementDialogVisible = $event;
      },
      confirm: _vm.getData
    }
  }), _c("supplement-record-dialog", {
    attrs: {
      visible: _vm.supplementRecordDialogVisible,
      currentId: _vm.currentId
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.supplementRecordDialogVisible = $event;
      },
      resolve: _vm.toAction
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };